import { StudentNotesPanel } from '../../features/notes/StudentNotesPanel';
import { formatDuration } from '../../features/pilotMath/format';
import { pilotSummary } from '../../features/pilotMath/store';
import { usePilotState } from '../../features/pilotMath/usePilotState';
import { RuntimeBackendCard } from '../../features/runtime/RuntimeBackendCard';

export function AdminDashboard() {
  const [state] = usePilotState();
  const summary = pilotSummary(state);

  return (
    <div className="stack">
      <div><h1>Dashboard Admin</h1><p className="muted">Pilot admin view memakai record belajar yang sama dengan siswa, tutor, dan orang tua.</p></div>
      <section className="grid grid--3">
        <div className="metric"><span>Demo murid aktif</span><strong>{state.status === 'in_progress' ? 1 : 0}</strong></div>
        <div className="metric"><span>Soal selesai</span><strong>{summary.completed}</strong></div>
        <div className="metric"><span>Waktu aktif</span><strong>{formatDuration(summary.totalActiveMs)}</strong></div>
      </section>
      <RuntimeBackendCard />
      <StudentNotesPanel studentId={state.student.id} viewerRole="branch_admin" authorName="Admin BelajarKu" allowCreate defaultNoteType="follow_up" subjectCode="MTH" title={`Catatan ${state.student.displayName}`} />
    </div>
  );
}
